// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { loadComponentLabelsData, getSubNavigationData } from '@tcp/core/src/reduxStore/actions';
import { trackPageView, setClickAnalyticsData } from '@tcp/core/src/analytics/actions';
import { toggleApplyNowModal } from '@tcp/core/src/components/common/molecules/ApplyNowPLCCModal/container/ApplyNowModal.actions';
import { getAPIConfigForAdobe, getUserState } from '@tcp/core/src/adobeAnalytics/adobe.selectors';
import WalletView from '../views';

import { getWalletFooterLinks } from './Wallet.selectors';
import { getUserLoggedInState } from '../../User/container/User.selectors';
import {
  getPageNameFromState,
  getWalletCouponRedesign,
  getPlccOfferPercentage,
} from '../../../../../reduxStore/selectors/session.selectors';
import { getPLCCDiscountValue } from '../../../../common/organisms/Promotions/container/Promotions.selectors';

export const WalletContainer = (props) => {
  const {
    isUserLoggedIn,
    footerLinks,
    isWalletCouponRedesign,
    plccOfferPercentage,
    ...otherProps
  } = props;
  return (
    <WalletView
      isUserLoggedIn={isUserLoggedIn}
      footerLinks={footerLinks}
      isWalletCouponRedesign={isWalletCouponRedesign}
      plccOfferPercentage={plccOfferPercentage}
      {...otherProps}
    />
  );
};

export const mapStateToProps = (state) => {
  return {
    isUserLoggedIn: getUserLoggedInState(state),
    footerLinks: getWalletFooterLinks(state),
    loyaltyPageName: getPageNameFromState(state),
    isWalletCouponRedesign: getWalletCouponRedesign(state),
    User: getUserState(state),
    APIConfig: getAPIConfigForAdobe(state),
    plccOfferPercentage: getPLCCDiscountValue(state) || getPlccOfferPercentage(state),
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    fetchLabels: (payload) => {
      dispatch(loadComponentLabelsData(payload));
    },
    openApplyNowModal: (payload) => {
      dispatch(toggleApplyNowModal(payload));
    },
    fetchFooterLinks: (payload) => {
      dispatch(getSubNavigationData(payload));
    },
    trackPageLoad: (payload) => {
      dispatch(
        setClickAnalyticsData({
          customEvents: ['event80'],
          pageNavigationText: payload.pageNavigationText,
        })
      );
      dispatch(trackPageView(payload));
      const analyticsTimer = setTimeout(() => {
        dispatch(setClickAnalyticsData({}));
        clearTimeout(analyticsTimer);
      }, 100);
    },
  };
};

WalletContainer.propTypes = {
  labels: PropTypes.shape({}),
  commonLabels: PropTypes.shape({}),
  accountLabels: PropTypes.shape({}),
  fetchLabels: PropTypes.func,
  isUserLoggedIn: PropTypes.bool,
  fetchFooterLinks: PropTypes.func,
  footerLinks: PropTypes.shape([]),
  trackPageLoad: PropTypes.func,
  User: PropTypes.shape({}),
  APIConfig: PropTypes.shape({}),
};

WalletContainer.defaultProps = {
  labels: {},
  commonLabels: {},
  accountLabels: {},
  fetchLabels: () => {},
  isUserLoggedIn: false,
  fetchFooterLinks: () => {},
  footerLinks: [],
  trackPageLoad: () => {},
  User: {},
  APIConfig: {},
};

export default connect(mapStateToProps, mapDispatchToProps)(WalletContainer);
